import { BathIcon } from 'assets/icons/BathIcon';
import { BedIcon } from 'assets/icons/BedIcon';

import './styles.scss';
import { ArrowLeft } from 'assets/icons/ArrowLeft';
import { DisclaimerCard } from 'components/DisclaimerCard';
import DropdownMenu from 'components/DropdownMenu';
import { InfoCircle } from 'assets/icons/InfoCircle';
import React, { useState } from 'react';
import { APARTMENT_ADAPTER } from 'consts';
import CollapsibleCard from 'components/CollapsibleCard';
import FullscreenPopup from 'components/PanoPopup/FullscreenPopup';
import { useDispatch } from 'react-redux';
import { setIsPopupOpen, updateWorldParams } from 'store/actions';
import { useTranslation } from 'react-i18next';

// "68fae8fadef8ab14e0c4deae"

export const ApartmentInfo = ({ onBack, data }) => {
  const dispatch = useDispatch();
  const { type } = data;
  const [vr, setVr] = useState({ isOpen: false, sceneId: '' });

  const isDesktop = window.innerWidth > 768;
  // window.isFirstVisitApartmentInfo = true;

  const handleShowVr = () => {
    const sceneId = APARTMENT_ADAPTER[type]?.scene;

    if (!sceneId) {
      console.error('No sceneId found for apartment type:', type);
      return;
    }
    setVr({ isOpen: true, sceneId });
    dispatch(setIsPopupOpen(true));

    // if (!window.isFirstVisitApartmentInfo) {
    //   dispatch(setGuideBoardVisible(true));
    //   window.isFirstVisitApartmentInfo = false;
    // }

    dispatch(updateWorldParams({ sceneId }));
  };

  return (
    <>
      <div className="apartment-info">
        <CollapsibleCard className={`apartment-info-container `}>
          {/* <PerfectScrollbar> */}
          <CollapsibleCard.Content>
            <InfoCard onClick={handleShowVr} data={data} />
          </CollapsibleCard.Content>
          {/* </PerfectScrollbar> */}
        </CollapsibleCard>

        <button className="back-btn" onClick={onBack}>
          <ArrowLeft />
          Back
        </button>
        <div className="apartment-floor-plan">
          <img
            src={APARTMENT_ADAPTER[type].mini}
            // src={'/assets/images/floorImg/3pn.webp'}
            alt={`Layout căn hộ ${APARTMENT_ADAPTER[type].label}`}
          />
        </div>
        {/* <div className="disclaimer-card-container"> */}

        {isDesktop ? (
          <DisclaimerCard />
        ) : (
          <DropdownMenu className="dropdown-mobile">
            <DropdownMenu.Trigger>
              <InfoCircle />
            </DropdownMenu.Trigger>
            <DropdownMenu.Content align="end" side="bottom" sideOffset={40}>
              <DisclaimerCard />
            </DropdownMenu.Content>
          </DropdownMenu>
        )}
      </div>
      <FullscreenPopup
        isOpen={vr.isOpen}
        onClose={() => setVr({ isOpen: false, sceneId: '' })}
        sceneId={vr.sceneId}
      />
    </>
  );
};

const InfoCard = ({ onClick, data }) => {
  const { t } = useTranslation();
  const { type, usageArea, wallArea } = data;
  const { label, wc, bed } = APARTMENT_ADAPTER[type];
  return (
    <div className="apartment-info-card">
      <div className="top">
        <p className="title">{t(label)}</p>
        <div className="description">
          <div className="text">
            <BathIcon />
            <span>WC</span>
            <span>{wc}</span>
          </div>
          <div className="divider" />
          <div className="text">
            <BedIcon />
            <span>{t('bedroom')}</span>
            <span>{bed}</span>
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="bottom-item">
          <p>{t('net_floor_area')}</p>
          <p>{usageArea}m2</p>
        </div>
        <div className="bottom-item">
          <p>{t('built_up_area')}</p>
          <p>{wallArea}m2</p>
        </div>
      </div>
      <button onClick={onClick}>{t('watch_vr')}</button>
    </div>
  );
};
